export const PROGRAM_SUPPORTS = 'Program Supports'
export const PROGRAM_TRAINING = 'Program Training'
